var map = {
	"./ch-alan_walker.png": 100,
	"./ch-ariana_grande.png": 101,
	"./ch-aya_nakamura.png": 102,
	"./ch-bad_bunny.png": 103,
	"./ch-billie_eilish.png": 104,
	"./ch-capital_bra.png": 105,
	"./ch-daddy_yankee.png": 106,
	"./ch-ed_sheeran.png": 107,
	"./ch-j_balvin.png": 108,
	"./ch-katy_perry.png": 109,
	"./ch-koba_lad.png": 110,
	"./ch-lady_gaga.png": 111,
	"./ch-maitre_gims.png": 112,
	"./ch-maluma.png": 113,
	"./ch-nicky_jam.png": 114,
	"./ch-ninho.png": 115,
	"./ch-niska.png": 116,
	"./ch-ozuna.png": 117,
	"./ch-pnl.png": 118,
	"./ch-soprano.png": 119
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99;